export const M_LEAN_EMAIL_SUPPORT = 'support@mlean.com'

export const TIME_BEFORE_SEARCH = 800
export const TRANSITION_DURATION = 0.6
export const EVIDENCE_VIDEO_TYPE = 1
export const EVIDENCE_IMAGE_TYPE = 0
export const GOOD_PRACTICE = 0
export const REFERENCE = 1
export const BAD_PRACTICE = 2

export const NOTIFICATION_TIMEOUT = 7000
export const SEARCH_INPUT_DELAY_MS = 200
export const INVALID_ID = -1
export const ALERT_TYPE_CONFIRMATION = 'ALERT_TYPE_CONFIRMATION'
export const ALERT_TYPE_QUESTION = 'ALERT_TYPE_QUESTION'
export const WEB_URL_LINK_REGEX = /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w~%:?#[\]@!$&'()*+,;=]+$/gm

export const Z_INDEX_DEFAULT = 'auto'
export const Z_INDEX_OVERALL = '1030'

export const NOK_STATUS = 0
export const OK_STATUS = 1
export const NA_STATUS = -2

export const MODE_NONE = 0
export const MODE_CREATE = 1
export const MODE_EDIT = 2
export const MODE_VIEW = 3
export const MODE_CREATE_PMM = 4
export const MODE_VIEW_PMM = 5

export const BLANK_SPACE = ' '
export const COLON_SEPARATOR = ': '
export const COMMA_SEPARATOR = ', '
export const EMPTY_STRING = ''
export const MINUS_SEPARATOR = '<= '
export const NA = 'NA'
export const PERCENTAGE_CHAR = '%'
export const PLUS_SEPARATOR = '>= '

export const ALLOWED_PHOTO_TYPES = Object.freeze(['jpg', 'jpeg', 'png', 'bmp'])
export const ALLOWED_VIDEO_TYPES = Object.freeze(['mp4', 'mov'])
export const ALLOWED_DOCUMENT_FILE_TYPES = Object.freeze(['pdf', 'xls', 'xlsx', 'doc', 'docx', 'ppt', 'pptx'])

export const SR_CHARACTERISTIC_ICON_MAX_WIDTH = 256
export const SR_CHARACTERISTIC_ICON_MAX_HEIGHT = 256

export const NO_RESULT_SELECTOR_VALUE = -99

export const SPONTANEOUS_SOURCES_APPS = [
  'LeanCenter',
  'sources.messages.lean_center',
  'sources.messages.cockpit',
  'sources.messages.self_assessment',
  'sources.messages.diagnosis',
]

export const LEAN_CENTER_MODULES = ['actions', 'escalated_actions', 'audits', 'problems', 'myStandards', 'pendingStandards', 'alerts', 'improvementIdeas', 'standard_work_audits']

export const ALERT_SOURCE = 'Alerts'
export const DAILY_ROUND_SOURCE = 'Cockpit'
export const FIVES_SOURCE = 'FiveSMethod'
export const GEMBA_WALK_SOURCE = 'DRGembaWalk'
export const IMPROVEMENT_IDEA_SOURCE = 'ImprovementIdea'
export const LEAN_CENTER_SOURCE = 'LeanCenter'
export const MASTER_AUDIT_SOURCE = 'MasterAudit'
export const TASK_MANAGER_SOURCE = 'TaskManager'
export const OK1STPART_SOURCE = 'OK1stPart'
export const SWR_SOURCE = 'StandardWorkReview'

export const MANDATORY_NOK_PICTURE = 'MANDATORY_NOK_PICTURE'
export const MANDATORY_OK_PICTURE = 'MANDATORY_OK_PICTURE'
export const MANDATORY_COMMENT = 'MANDATORY_COMMENT'
export const AUDITS_ACTION_EVIDENCES = 'AUDITS_ACTION_EVIDENCES'
export const ENABLE_PMM_INTEGRATION = 'ENABLE_PMM_INTEGRATION'

export const HSE_RISKS_SOURCE = 'hse_risk'

export const CONFIGURATION_KEYS = {
  ACTIONS_EMAIL_NOTIFICATIONS: 'ACTIONS_EMAIL_NOTIFICATIONS',
  ACTIONS_GMAO_POST_TO_REMOTE_SYSTEM_URL: 'ACTIONS_GMAO_POST_TO_REMOTE_SYSTEM_URL',
  ALERTS_OPEN_VS_CLOSED_CHART: 'ALERTS_OPEN_VS_CLOSED_CHART',
  ALERTS_TOP_5_CHART: 'ALERTS_TOP_5_CHART',
  ANALYSIS_4M_CONFIG: 'ANALYSIS_TOOLS_CONFIGURATION.4M',
  ANALYSIS_5M_CONFIG: 'ANALYSIS_TOOLS_CONFIGURATION.5M',
  ANALYSIS_5WHYS_CONFIG: 'ANALYSIS_6M_CONFIGURATION.5WHYS',
  ANALYSIS_6M_CONFIG: 'ANALYSIS_TOOLS_CONFIGURATION.6M',
  ANALYSIS_CAUSETOOL_CONFIG: 'ANALYSIS_TOOLS_CONFIGURATION.CAUSETOOL',
  APPS_HOW_INSTALL: 'APPS_HOW_INSTALL',
  ASSESSMENT_TABLE_CHART: "ASSESSMENT_TABLE_CHART_",
  ASSESSMENTS_SOURCES_WITH_MULTIPLE_MEASURES: 'ASSESSMENTS_SOURCES_WITH_MULTIPLE_MEASURES',
  AUDITS_ACTION_EVIDENCES: 'AUDITS_ACTION_EVIDENCES',
  AUDITS_GRAPH_TYPE: "AUDITS_GRAPH_TYPE",
  AUDITS_PREVIOUS_COMMENTS_TIME_CONFIG: "LPAS.PREVIOUS_COMMENTS.TIME_CONFIGURATION",
  AVERAGE_CHART: "AVERAGE_CHART_",
  AVERAGE_SCORE_FAMILY_CHART: "AVERAGE_SCORE_FAMILY_CHART_",
  AVERAGE_SCORE_BY_FAMILY_SPIDER_CHART: "AVERAGE_SCORE_BY_FAMILY_SPIDER_CHART_",
  AVERAGE_TREND_INDICATOR: "AVERAGE_TREND_INDICATOR_",
  CHART_VISIBILITY_CONFIG: "CHART_VISIBILITY",
  CHARTS_CONFIG: "CHARTS_CONFIG",
  CLOSED_ACTIONS_INDICATOR: "CLOSED_ACTIONS_INDICATOR_",
  COMMITTED_CHART: "COMMITTED_CHART_",
  COMPLIANCE_ACTIONS_DEADLINES_CHART: "COMPLIANCE_ACTIONS_DEADLINES_CHART_",
  CONFORMITY_RATE: "CONFORMITY_RATE_",
  CREATED_CLOSED_ACTIONS_CHART: "CREATED_CLOSED_ACTIONS_CHART_",
  CREATED_PROBLEM_PER_PILOT_KPIS_GRAPHS: "CREATED_PROBLEM_PER_PILOT_KPIS_GRAPHS",
  DR_ACTIVITIES_PREVIOUS_COMMENTS_TIME_CONFIG: "LEAN_CENTER.PREVIOUS_COMMENTS.ACTIVITIES.TIME_CONFIGURATION",
  EFFICIENCY_PLAN_CONFIG: "PROBLEMS_CONFIGURATION.ACTION_PLAN_EFFICIENCY",
  ENABLE_ACTION_EFFECTIVENESS_PARTIALLY: 'ENABLE_ACTION_EFFECTIVENESS_PARTIALLY',
  ENABLE_PRIVACY_POLICY_ALERT: "ENABLE_PRIVACY_POLICY_ALERT",
  ENABLE_PROBLEM_SUPERVISOR: 'PROBLEMS_CONFIGURATION.ENABLE_PROBLEM_SUPERVISOR',
  ENABLE_ROTATION_TABLE: 'ENABLE_ROTATION_TABLE',
  ENABLE_SFM: 'ENABLE_SFM',
  ENABLE_LINE_BOARD: 'ENABLE_LINE_BOARD',
  ENABLE_TM_GROUPS_ALTERING_SCHEDULE: 'ENABLE_TM_GROUPS_ALTERING_SCHEDULE',
  LINE_BOARD_NAME: 'LINE_BOARD_NAME',
  EVOLUTION_CHARTS_CONFIG: "EVOLUTION_CHARTS",
  FULL_SCREEEN_REFRESH_MINUTES: "FULL_SCREEEN_REFRESH_MINUTES",
  GEMBA_WALK_CHECKPOINTS_EVOLUTION_TREND: "GEMBA_WALK_CHECKPOINTS_EVOLUTION_TREND",
  GEMBA_WALK_NUMBER_OF_ASSESSMENTS_RESULT: "GEMBA_WALK_NUMBER_OF_ASSESSMENTS_RESULT",
  GEMBA_WALK_PREVIOUS_COMMENTS_TIME_CONFIG: "LEAN_CENTER.PREVIOUS_COMMENTS.GEMBA_WALK.TIME_CONFIGURATION",
  HOSHIN_KANRI_ENABLE_MANAGER: "HOSHIN_KANRI.ENABLE_MANAGER",
  IMPROVEMENT_IDEA_GRAPH_TYPE: "IMPROVEMENT_IDEA_GRAPH_TYPE",
  IMPROVEMENT_IDEAS_OUT_OF_TIME_INDICATOR: "IMPROVEMENT_IDEAS_OUT_OF_TIME_INDICATOR",
  IMPROVEMENT_IDEAT_NOT_VALIDATED_INDICATOR: "IMPROVEMENT_IDEAT_NOT_VALIDATED_INDICATOR",
  IMPROVEMENT_IDEAT_STATUS_PIE_CHART: "IMPROVEMENT_IDEAT_STATUS_PIE_CHART",
  SWR_CONFIGURATION: "SWR_CONFIGURATION",
  IS_CAPABILITY_TO_REACH_SWT_ENABLED: "IS_CAPABILITY_TO_REACH_SWT_ENABLED",
  LAST_AVERAGE_SCORE_INDICATOR: "LAST_AVERAGE_SCORE_INDICATOR_",
  LATEST_OBSERVATION_INDICATOR: "LATEST_OBSERVATION_INDICATOR_",
  LEAN_CENTER_TIME_TRACKING_ENABLED: "LEAN_CENTER.LEAN_CENTER_TABS.TIME_TRACKING",
  LEAN_CENTER_LEAN_CENTER_TABS_ALERTS_ENABLED: "LEAN_CENTER.LEAN_CENTER_TABS.ALERTS",
  MANDATORY_CAUSE_DESCRIPTION_TO_CLOSE_ACTIONS: 'MANDATORY_CAUSE_DESCRIPTION_TO_CLOSE_ACTIONS',
  MANDATORY_COMMENT: 'MANDATORY_COMMENT',
  MANDATORY_EFFECTIVENESS_TO_CLOSE_ACTIONS: 'MANDATORY_EFFECTIVENESS_TO_CLOSE_ACTIONS',
  MANDATORY_ISSUE_DESCRIPTION_TO_CLOSE_ACTIONS: 'MANDATORY_ISSUE_DESCRIPTION_TO_CLOSE_ACTIONS',
  MANDATORY_NOK_PICTURE: 'MANDATORY_NOK_PICTURE',
  MANDATORY_OK_PICTURE: 'MANDATORY_OK_PICTURE',
  MIDDLE_NOTE_THRESHOLD: "MIDDLE_NOTE_THRESHOLD_",
  NON_COMPLIANCE_CHART: "NON_COMPLIANCE_CHART_",
  NUMBER_OF_EXPIRED_IMPROVEMENT_IDEAS_INDICATOR: "NUMBER_OF_EXPIRED_IMPROVEMENT_IDEAS_INDICATOR",
  OBSERVATIONS_NON_COMPLIANCE_CHART: "OBSERVATIONS_NON_COMPLIANCE_CHART_",
  OK_FIRST_PART_EMAILS: "OK_FIRST_PART_EMAILS",
  OK_FIRST_PART_NON_COMFORMITIES_EMAILS: "OK_FIRST_PART_NON_COMFORMITIES_EMAILS",
  OK_FIRST_PART_SIGN_CONDITIONAL_OK_ROLES: "OK_FIRST_PART_SIGN_CONDITIONAL_OK_ROLES",
  OK_FIRST_PART_SIGN_NOK_ROLES: "OK_FIRST_PART_SIGN_NOK_ROLES",
  OK_FIRST_PART_SIGN_OK_ROLES: "OK_FIRST_PART_SIGN_OK_ROLES",
  OLDEST_PROBLEM_KPIS_GRAPHS: "OLDEST_PROBLEM_KPIS_GRAPHS",
  ONLY_CREATOR_CAN_DELETE_ACTIONS: "ONLY_CREATOR_CAN_DELETE_ACTIONS",
  ONLY_CREATOR_CAN_VERIFY_ACTIONS: "ONLY_CREATOR_CAN_VERIFY_ACTIONS",
  OPERATOR_COMPLIANCE_TABLE: "OPERATOR_COMPLIANCE_TABLE_",
  PERCENT_COMPLETE_GRAPH: "PERCENT_COMPLETE_GRAPH_",
  PRESENTATION_EMAIL_NOTIFICATIONS: "PRESENTATION_EMAIL_NOTIFICATIONS",
  PROBLEM_COACHING_TOOL: "PROBLEM_COACHING_TOOL",
  PROBLEM_DOCUMENTATION_REVIEW: 'PROBLEM_DOCUMENTATION_REVIEW',
  PROBLEM_ESCALATION_TOOL: "PROBLEM_ESCALATION_TOOL",
  PROBLEM_KPIS_GRAPHS: "PROBLEM_KPIS_GRAPHS",
  PROBLEMS_SIGNATURE_CONFIG: 'PROBLEMS_CONFIGURATION.ENABLE_PROBLEMS_SIGNATURE',
  ROLES_THAT_CAN_NOT_SEE_IMPROVEMENT_IDEA_TIME_SAVE: 'ROLES_THAT_CAN_NOT_SEE_IMPROVEMENT_IDEA_TIME_SAVE',
  ROLES_THAT_CAN_NOT_SEE_IMPROVEMENT_IDEA_MONEY_INVESTED: 'ROLES_THAT_CAN_NOT_SEE_IMPROVEMENT_IDEA_MONEY_INVESTED',
  ROLES_THAT_CAN_NOT_SEE_IMPROVEMENT_IDEA_MONEY_SAVED: 'ROLES_THAT_CAN_NOT_SEE_IMPROVEMENT_IDEA_MONEY_SAVED',
  ROLES_WITH_PERMISSIONS_OVER_CONSOLIDATED_REPORTS: "ROLES_WITH_PERMISSIONS_OVER_CONSOLIDATED_REPORTS",
  ROLES_WITH_PERMISSIONS_OVER_DIAGNOSIS: "ROLES_WITH_PERMISSIONS_OVER_DIAGNOSIS",
  ROLES_WITH_PERMISSIONS_OVER_SELF_ASSESSMENTS: "ROLES_WITH_PERMISSIONS_OVER_SELF_ASSESSMENTS",
  ROOT_CAUSE_POSITION_TOP: "PROBLEMS_CONFIGURATION.ROOT_CAUSE_POSITION_TOP",
  SETTINGS_CONFIGURATION_VIEW: 'SETTINGS_CONFIGURATION_VIEW',
  SHOW_FIVEWHYS_REMINDER: "PROBLEMS_CONFIGURATION.SHOW_FIVEWHYS_REMINDER",
  SHOW_IMPROVEMENT_IDEA_MODULE: 'SHOW_IMPROVEMENT_IDEA_MODULE',
  SHOW_MONEY_REAL_SAVED_KEY: 'SHOW_MONEY_REAL_SAVED_KEY',
  SKILL_MATRIX_COMPLIANCE_THRESHOLDS: "SKILL_MATRIX.COMPLIANCE_THRESHOLDS",
  SKILL_MATRIX_EVALUATE_STANDARDS: "SKILL_MATRIX.EVALUATE_STANDARDS",
  SKILL_MATRIX_OBSERVATION_INDICATOR: "SKILL_MATRIX.OBSERVATION_INDICATOR",
  SKILL_MATRIX_QUALITY_FAILURES_CONFIG: "SKILL_MATRIX.QUALITY_FAILURES_CONFIG",
  SKILL_MATRIX_PEOPLE_IDENTIFIER_FORMAT: 'SKILL_MATRIX.PEOPLE_IDENTIFIER_FORMAT',
  STANDARD_CONFIGURATION_ONLY_ADMIN_CAN_DELETE_STANDARDS: "STANDARD_CONFIGURATION.ONLY_ADMIN_CAN_DELETE_STANDARDS",
  STANDARD_CONFIGURATION_REFERENCE_STANDARDS: "STANDARD_CONFIGURATION.REFERENCE_STANDARDS",
  STANDARD_CONFIGURATION_STANDARD_IMPROVEMENT_UTILS: "STANDARD_CONFIGURATION.STANDARD_IMPROVEMENT_UTILS",
  STANDARD_CONFIGURATION_VIDEO_PLAYER_BEHAVIOUR: "STANDARD_CONFIGURATION.VIDEO_PLAYER_BEHAVIOUR",
  SYSTEM_CONFIGURATION: 'SYSTEM_CONFIGURATION',
  TABLE_COLUMNS: 'TABLE_COLUMNS',
  TASK_MANAGER_CHECKPOINT_BY_PRODUCTS: "TASK_MANAGER_CHECKPOINT_BY_PRODUCTS",
  TASK_MANAGER_CHECKPOINT_HISTORY_LIMIT: "TASK_MANAGER_CHECKPOINT_HISTORY_LIMIT",
  THRESHOLDS_CONFIG: 'THRESHOLDS',
  TIME_BETWEEN_INDICATOR: "TIME_BETWEEN_INDICATOR_",
  TIME_CYCLE_TOLERANCE: "TIME_CYCLE_TOLERANCE",
  TPM_PREVIOUS_COMMENTS_TIME_CONFIG: "TASK_MANAGER.PREVIOUS_COMMENTS.TIME_CONFIGURATION",
  VARIABLE_NUMBER_OF_RESULTS_CHARTS_CONFIG: "VARIABLE_NUMBER_OF_RESULTS_CHARTS",
  VISUAL_STANDARD_IN_DETAIL_FILTERS: 'VISUAL_STANDARD_IN_DETAILS_FILTER_FIELDS',
  VISUAL_STANDARD_SEVEN_WASTES_LIST_FILTERS: 'VISUAL_STANDARD_SEVEN_WASTES_LIST_FILTER_FIELDS',
  WEEKLY_MEETING_DAYS: "WEEKLY_MEETING_DAYS",
  WORKING_DAYS: "WORKING_DAYS",
  WORST_CRITERIA_CHART: "WORST_CRITERIA_CHART_",
}

export const PORTAL_LEVELS = {
  ONE: 'modal-level-1',
  TWO: 'modal-level-2',
  THREE: 'modal-level-3',
  LOGIN: 'modal-login-permissions',
  TOASTS: 'toasts',
}

export const HEADER_OPTIONS = {
  TITLE: 'title',
  AUTHOR: 'author',
  BADGE: 'badge',
}

export const TIME_FRAME_UNITS = {
  SECONDS: {
    id: 0,
    token: "task_manager.messages.seconds",
    name: "seconds",
  },
  MINUTES: {
    id: 1,
    token: "task_manager.messages.minutes",
    name: "minutes",
  },
  HOURS: {
    id: 2,
    token: "task_manager.messages.hours",
    name: "hours",
  },
}

export const DEBOUNCE_TIME_MEDIUM = 1000

export const NUMBER_OF_ITEMS_IN_TABLE = 25

export const COLOR_OK_CELL = 'tw-text-core-primary-10'
export const COLOR_NOK_CELL = 'tw-text-auxiliary-error-40'
export const COLOR_NA_CELL = 'tw-text-core-neutral-cold-60'
export const COLOR_CONDITIONAL_OK = 'tw-text-extra-orange-60'
